// extracted by mini-css-extract-plugin
export var migrationStepperAcknowledgeBox = "migration-stepper-acknowledge-box_mANYa68cbY72lQGtGtqA";
export var migrationStepperSectionHeader = "migration-stepper-section-header_dKU1lWbACf6OAuYUdyS7";
export var migrationStepperStepper = "migration-stepper-stepper_ag9xmAFgh73gjnOuocBW";
export var migrationStepperSuccessMessage = "migration-stepper-success-message_lkIkwH5ttX1AK0p85sKm";